<template>
  <div id="app">
    <enquiry-form></enquiry-form>
  </div>
</template>

<script>
import Loading from './Loading'
import EnquiryForm from './forms/enquiry-form'

export default {
	el: '#app',

	components: {
		Loading,
		EnquiryForm
	},

	metaInfo () {
		const { appName } = window.config

		return {
			title: appName,
			titleTemplate: `%s · ${appName}`
		}
	},

	data: () => ({
		layout: null,
		defaultLayout: 'app'
	}),

	mounted () {
	},

	methods: {

	}
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/frontend-vue/components/App.vue